
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-15566.849 16596.152 16.634 16.697"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Group_8267","data-name":"Group 8267","transform":"translate(-16034 16412)"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_3580","d":"M3.55 6.746a1.581 1.581 0 0 1 .888-1.42V2.219A2.2 2.2 0 0 0 2.219 0 2.2 2.2 0 0 0 0 2.219v3.2a1.581 1.581 0 0 1 .888 1.42A1.581 1.581 0 0 1 0 8.255v1.864h4.438V8.166a1.581 1.581 0 0 1-.888-1.42z","data-name":"Path 3580","transform":"rotate(45 16.585 671.669)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_3581","d":"M.533 0l.621 2.485H0z","data-name":"Path 3581","transform":"rotate(45 -3.437 665.76)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Line_1776","d":"M0 0v5.769","data-name":"Line 1776","transform":"rotate(45 3.26 669.288)"}})])])
          )
        }
      }
    